import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountPage from './AccountPage';
import Priorities from './Priorities';
import OpTypes from './OpTypes';
import DataDestinations from './DataDestinations';

const Account = ({ match }) => (
   <Switch>
      <Route path={`${match.url}/optypes`} component={OpTypes} />
      <Route path={`${match.url}/priorities`} component={Priorities} />
      <Route path={`${match.url}/data-destinations`} component={DataDestinations} />
      <Route path={`${match.url}/`} component={AccountPage} />
   </Switch>
);

export default Account;
